export enum BLOCKED_TYPE {
  IP_LIMIT_REGISTRATION = 'ip_limit_registration',
  IP_BLACK_LIST = 'ip_black_list',
  IP_DATA_CENTER = 'ip_data_center',
  IP_PROXY = 'ip_proxy',
  IP_CLICK_CAPPING = 'ip_click_capping',
  EVENT_CAPPING = 'event_capping',

  DOMAIN_INFECTED = 'domain_infected',
  DOMAIN_USER_LIST = 'domain_user_list',
  DOMAIN_MISLEADING = 'domain_misleading',
  DOMAIN_ADULTS = 'domain_adults',

  APP_SUSPICIOUS = 'app_suspicious',
  APP_UNKNOWN = 'app_unknown',
  HIDDEN_BY_METAREFRESH = 'hidden_by_metarefresh',
  APP_FAKE = 'app_fake',
  APP_NEW_COUNT = 'app_new_count',
  APP_ADULTS = 'app_adutls',
  APP_USER_LIST = 'app_user_list',

  INVALID_REFERRER = 'invalid_referrer',
  INVALID_USER_AGENT = 'invalid_user_agent',
  REGISTRATION_BY_DEVICE = 'registration_by_device',
  HIDDEN_INFORMATION = 'hidden_information',
  INVALID_LOCALIZE = 'invalid_localize',
  FARM_DEVICES = 'farm_devices',
  EMULATOR_BOTS = 'emulator_bots',

  PRELANDING_CONTROL = 'prelanding_control',
  CREATIVITY_CONTROL = 'creativity_control',

  REQUIERE_DOMAIN_OR_BUDLE = 'require_domain_or_bundle',
  REQUIRE_DEVICE_ID = 'require_device_id',
  REQUIRE_REFERER = 'require_referer',

  URL_PARAMETERS_VALIDATION_INAPP = 'require_url_parameters_validation_inapp',
  URL_PARAMETERS_VALIDATION_CLICK = 'require_url_parameters_validation_click',
  URL_PARAMETERS_BLOCKING_INAPP = 'require_url_parameters_blocking_inapp',
  URL_PARAMETERS_BLOCKING_CLICK = 'require_url_parameters_blocking_click',

  VPN_PROXY_IP_INAPP = 'vpn_proxy_ip_inapp',
  VPN_PROXY_IP_CLICK = 'vpn_proxy_ip_click',

  INAPP_TRAFFIC = 'inapp_traffic',
  RATE_DEVICE = 'rate_device',
  RATE_LANGUAGE = 'rate_language',
  RATE_IP = 'rate_ip',
  RATE_APP = 'rate_app',
  RATE_CAPS = 'rate_caps',
  RATE_CHANGE_OFFER_STATUS = 'rate_change_offer_status',
  REGISTRATION_TOO_FAST = 'registration_too_fast',
  REGISTRATION_TOO_SLOW = 'registration_too_slow',
  TOO_OLD_BROWSER_VERSION = 'too_old_browser_version',
  MSISDN_SUBSCRIPTION_NUMBER = 'msisdn_subscription_number',
  CLIENT_UNIQUE_TRANSACTION = 'client_unique_transaction',

  FILTER_OS = 'filter_os',
  FILTER_BROWSER = 'filter_browser',
  FILTER_DEVICE = 'filter_device',
  FILTER_CONNECTION_TYPE = 'filter_connection_type',
  FILTER_COUNTRY = 'filter_country',
  FILTER_REGION = 'filter_region',
  FILTER_CITY = 'filter_city',
  FILTER_WEEK_DAYS = 'filter_week_days',
  FILTER_HOURS = 'filter_hours',
  FILTER_TIMEZONE = 'filter_timezone',
  PROVIDER_QUERY_PARAMS = 'provider_query_params',
  EXPIRED_OFFER_DATES = 'expired_offer_dates',
  EXPIRED_CAMPAIGN_DATES = 'expired_campaign_dates',
  CAMPAIGN_NOT_EXISTS = 'campaign_not_exists',
}
